import classNames from 'classnames';
import type * as React from 'react';
import styles from '../style.m.less';

interface Props {
    children: React.ReactNode;
    className?: string;
    hiddenFromView?: boolean;
    ariaRole?: string;
    ariaLive?: 'assertive' | 'polite';
    isAtomic?: boolean;
}

export default function AriaAnnouncer({
    children,
    className = '',
    hiddenFromView = true,
    ariaRole = 'status',
    ariaLive = 'assertive',
    isAtomic = true,
}: Props) {
    const cN = classNames({ [styles.offScreen]: hiddenFromView }, className);

    return (
        <div className={cN} aria-live={ariaLive} aria-atomic={isAtomic} role={ariaRole}>
            {children}
        </div>
    );
}
